var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-404"},[_vm._v(" 404 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }